export const trafficOptions = [
  { value: "0 - 3 000" },
  { value: "3 001 - 10 000" },
  { value: "10 000 - 30 000" },
  { value: "30 000 - 60 000" },
  { value: "60 000 - 100 000" },
  { value: "100 000+" },
]

export const roleOptions = [
  { value: "CRM-маркетолог" },
  { value: "Интернет-маркетолог" },
  { value: "Руководитель команды маркетинга" },
  { value: "Менеджер по продажам" },
  { value: "Руководитель отдела продаж" },
  { value: "Специалист поддержки клиентов" },
  { value: "Руководитель отдела поддержки" },
  { value: "CEO " },
]
